import React, { useState } from "react";
import ReactPlayer from "react-player";
import {
  Carousel
} from "react-bootstrap";

function ContentSlider({ items }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  const handleSelect = (selectedIndex) => {
    setActiveIndex(selectedIndex);
  };

  const slides = items.map((item) => {
    return (
      <Carousel.Item
        className="custom-tag"
        tag="div"
        key={item.id}
        onExiting={() => setAnimating(false)}
        onExited={() => setAnimating(false)}
      >
        <Carousel.Caption className="text-danger" />
        <ReactPlayer
          width="100%"
          height="350px"
          url={item.video_url}
        />
      </Carousel.Item>
    );
  });

  return (
    <div>
      <style>
        {`.custom-tag {
              max-width: 100%;
              background: black;
            }`}
      </style>
      <Carousel
        activeIndex={activeIndex}
        onSelect={handleSelect}
      >
        {slides}
      </Carousel>
    </div>
  );
}

export default ContentSlider;
